(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mid-hero-editable"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mid-collection-banners')) {
  customElements.define('mid-collection-banners', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mf-banners-track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.pages = [...this.querySelectorAll('[data-page]')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('.mf-banners-controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.pages.forEach((page, i) => page.addEventListener('click', () => this.go(i), options));
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth), true), 140);
      }, options);
      this.querySelector('.mf-banners-controls').addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const i = this.slides.findIndex(slide => slide.contains(event.target));
        if (i >= 0) this.go(i);
      }, options);
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      this.update(0, false);
      this.autoInterval = 5500;
      this.isPaused = false;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.pauseAutoplay(), options);
      this.addEventListener('mouseleave', () => this.resumeAutoplay(), options);
      this.addEventListener('focusin', () => this.pauseAutoplay(), options);
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.resumeAutoplay(); }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseAutoplay(); else this.resumeAutoplay(); }, options);
    }
    startAutoplay() {
      clearInterval(this.autoTimer);
      if (this.motionQuery?.matches || document.hidden || this.isPaused || this.slides.length < 2) return;
      this.autoTimer = setInterval(() => {
        if (!document.hidden && !this.isPaused) this.go(this.index + 1);
      }, this.autoInterval);
    }
    pauseAutoplay() {
      this.isPaused = true;
      clearInterval(this.autoTimer);
    }
    resumeAutoplay() {
      this.isPaused = false;
      this.startAutoplay();
    }
    go(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.slides[next].inert = false;
      this.slides[next].removeAttribute('aria-hidden');
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update(index, announce) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.slides.forEach((slide, i) => {
        slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.pages.forEach((page, i) => {
        if (i === this.index) page.setAttribute('aria-current', 'true');
        else page.removeAttribute('aria-current');
      });
      if (announce) this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.scrollTimer);
      clearInterval(this.autoTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
